export default {
  headers: {
    title: 'List of invoices from third parties for costs incurred',
    created: 'Creation date',
    id: 'Serie - Number',
    provider: 'Provider',
    status: 'Status',
    type: 'Type',
    serie: 'Serie',
    number: 'Number',
    amount: 'Amount'
  },
  search: {
    title: 'Searcher'
  },
  filter: {
    byCreated: 'Creation date',
    byEmited: 'Issue date',
    from: 'From',
    to: 'To',
    byId: 'Serie and number',
    bySerie: 'Serie',
    byNumber: 'Number',
    byStatus: 'Status',
    byProviderDocument: 'Provider VAT Number',
    byAmount: 'Amount (€)'
  },
  delete: {
    confirmDeleteTitle: 'Delete selected third-party invoice',
    question: 'Are you sure you want to delete the selected third party invoice?'
  },
  send: {
    invoice: 'Send invoice',
    invoices: 'Send invoices'
  }
}
